import React from 'react';
import ReactDOM from 'react-dom';
import './_index.scss';

import App from './app/App';
import { FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react';

window.Buffer = require('buffer/').Buffer;

ReactDOM.render(
  <FpjsProvider
    loadOptions={{
      apiKey: process.env.REACT_APP_FINGERPRINT_PUBLIC_API_KEY,
      endpoint: [
        'https://fingerprint-metrics.tunl.com'
        // FingerprintJSPro.defaultEndpoint
      ],
      scriptUrlPattern: [
        'https://fingerprint-metrics.tunl.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js'
        // FingerprintJSPro.defaultScriptUrlPattern
      ]
      // region: "eu"
    }}
  >
    <App />
  </FpjsProvider>,
  document.getElementById('root')
);
